import { get, getBlob } from "../../../utils/axios";

export const getLocationOrgs = async (params = {}) => {
  return await get("/location", {
    orgId: params.orgId,
    onlyAssign: params.onlyAssign,
    limit: params.limit || 20,
    offset: params.offset || 0,
    search: params.search || null,
    current_lat: params.current_lat,
    current_lng: params.current_lng,
    search_radius: params.search_radius,
    status: params.status,
  });
};

export const downloadLocationOrgs = async (params = {}) => {
  return await getBlob("/location/download", {
    orgId: params.orgId,
    onlyAssign: params.onlyAssign,
    search: params.search || null,
    current_lat: params.current_lat,
    current_lng: params.current_lng,
    search_radius: params.search_radius,
    status: params.status,
  });
};
